import { render, staticRenderFns } from "./HeadingMobile.vue?vue&type=template&id=227c04ae&"
import script from "./HeadingMobile.vue?vue&type=script&lang=ts&"
export * from "./HeadingMobile.vue?vue&type=script&lang=ts&"
import style0 from "./HeadingMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileCarousel: require('/Users/markussh/git/theodora-tech-website/src/components/ProfileCarousel.vue').default,IconCornerLeftDown: require('/Users/markussh/git/theodora-tech-website/src/components/icon/CornerLeftDown.vue').default,CircleButton: require('/Users/markussh/git/theodora-tech-website/src/components/button/CircleButton.vue').default,AnimateHeading: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateHeading.vue').default})
